import app from '@/app';
import templateUrl from './composition-create-button.html';

var component = {
	templateUrl,
	require: {
		form: '^form'
	},
	bindings: {
		soft: '<',
		disabled: '<',
		readonly: '<',
		onAccept: '&',
		onReject: '&'
	}
};

app.component('prCompositionCreateButton', component);
